"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _default = {
  title: 'Scroll Snap In Sliding Galleries',
  description: "Choose if you want the closest image to snap in to place when scrolling horizontaly",
  isRelevant: function isRelevant(styleParams) {
    return styleParams.oneRow;
  },
  type: _constants.INPUT_TYPES.BOOLEAN,
  "default": false
};
exports["default"] = _default;